import { render } from "./dayStockHistory.vue?vue&type=template&id=c6452890"
import script from "./dayStockHistory.vue?vue&type=script&lang=js"
export * from "./dayStockHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__